module.exports = {
    styles:{
        'infw-footer'             : 'row pad custom-footer'
    },

    labels:{
        en: {

        },
        es: {

        }
    }
};



// WEBPACK FOOTER //
// ./application/src/themes/dxp_dumas.js